import { useTrackMarketplaceEvent } from 'marketplace-ui-tracking';
import { getMarketplaceInteractionEvent } from 'marketplace-ui-tracking/events/marketplace';
import { useCallback, useEffect, useRef } from 'react';
import { Subscreens } from '../../constants/usage';
const VIDEO_ORIGIN = 'https://play.hubspotvideo.com';
export function useVideoTracking({
  heroPosition,
  isActive,
  listingId,
  resultType,
  slug,
  videoId
}) {
  const trackMarketplaceEvent = useTrackMarketplaceEvent();
  const videoCurrentTimeRef = useRef(0);
  const trackInteraction = useCallback(action => {
    trackMarketplaceEvent(getMarketplaceInteractionEvent({
      action,
      listingId,
      itemIndex: heroPosition,
      resultType,
      slug,
      subscreen: Subscreens.HERO_SECTION,
      videoId,
      videoWatchedDuration: videoCurrentTimeRef.current
    }));
  }, [heroPosition, listingId, resultType, slug, trackMarketplaceEvent, videoId]);
  const trackInteractionRef = useRef(trackInteraction);
  trackInteractionRef.current = trackInteraction;
  useEffect(() => {
    if (!videoId || !isActive) return;
    const handleVideoEvent = message => {
      var _message$data$payload;
      if (message.origin !== VIDEO_ORIGIN) return;
      if (!message.data) return;

      // Not all events have a currentTime payload, so we need to update the currentTime ref if it exists
      if (((_message$data$payload = message.data.payload) === null || _message$data$payload === void 0 ? void 0 : _message$data$payload.currentTime) !== undefined) {
        videoCurrentTimeRef.current = message.data.payload.currentTime;
      }
      switch (message.data.type) {
        case 'PLAYER_PLAY':
          trackInteractionRef.current('hero video played (not on autoplay)');
          break;
        case 'PLAYER_PAUSE':
        case 'PLAYER_ENDED':
          {
            const action = message.data.type === 'PLAYER_PAUSE' ? 'hero video paused' : 'hero video finished';
            trackInteractionRef.current(action);
            break;
          }
        default:
          break;
      }
    };
    window.addEventListener('message', handleVideoEvent);
    return () => window.removeEventListener('message', handleVideoEvent);
  }, [videoId, isActive]);
  return {
    trackInteraction
  };
}